<template>
	<div v-if="loaded">
		<div class="pull-left cnt-btn-import">
			<label class="btn btn-warning">
				<input
					style="display: none"
					type="file"
					accept="text/xml"
					ref="selecor"
					@change="loadFile"
				/>
				<i class="fal fa-upload"></i>
				Importar Worklab
			</label>
		</div>
		<div class="clearfix"></div>

		<!-- <exames-nao-importados 
			:data="examesNaoRelacionados"
			:lines="lines"
		/> -->
		<!-- <pre>{{examesNaoRelacionados}}</pre> -->

		<item-importacao
			v-for="(item, index) in importDoc"
			:key="index"
			:mat="index"
			:exames="item"
		/>
	</div>
	<div v-else>
		<i class="fal fa-spin fa-spinner"></i>
		Carregando...
	</div>
</template>
<script>
	import { XML } from 'js/xml';
	import { camelCase } from 'lodash';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import ExamesNaoImportados from './components/exames-nao-importados';
	import ItemImportacao from './components/item-importacao';

	export default {
		components: {
			ItemImportacao,
			ExamesNaoImportados,
		},
		data() {
			return {
				loaded: false,
				lines: [],
				importDoc: [],
				examesNaoRelacionados: {},
				assets: {
					sd2000Tables: [],
					empresas: [],
					unidades: [],
					vetores: [],
				},
			};
		},
		methods: {
			async loadFile(ev) {
				if (ev.target.files.lenght == 0) return;

				let ReadXml = new XML(ev.target.files[0]);

				ReadXml.keyModify = camelCase;

				ReadXml.ignore = (nodeName, item) =>
					nodeName == '#text' && camelCase(item.data) == '';

				const { pacientes } = await ReadXml.simpleObj();

				let dataImport = {};
				pacientes.forEach(({ codigoFicha, exames }) => {
					dataImport[codigoFicha] = [];
					exames.forEach(({ codigo, resultados }) => {
						if (!Array.isArray(resultados))
							resultados = [resultados];
						resultados.forEach(({ parametro, valor }) => {
							if (!valor) return;
							const id = `${codigo}/${parametro}`;
							const dataLine = this.lines.find(
								(line) => line.id == id
							);

							if (!!dataLine) {
								dataImport[codigoFicha].push({
									id,
									valor,
									dataLine,
									importValue: valor,
								});
							} else {
								if (!this.examesNaoRelacionados[id])
									this.$set(this.examesNaoRelacionados, id, {
										values: [],
									});
								if (
									this.examesNaoRelacionados[
										id
									].values.indexOf(valor) == -1
								)
									this.examesNaoRelacionados[id].values.push(
										valor
									);
							}
						});
					});
				});

				this.importDoc = dataImport;
				this.$refs.selecor.value = '';
			},
		},
		provide() {
			let assets = {};
			for (let key in this.assets) {
				Object.defineProperty(assets, key, {
					enumerable: true,
					get: (e) => this.assets[key],
				});
			}

			return {
				assets,
			};
		},
		mounted() {
			this.$emit('setHeader', ['Impotar Exames', 'SD2000']);

			this.loaded = false;

			WBS.send('protected-read-sd2000Asstes', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
					WBS.send('protected-read-sd2000Import', (resp) => {
						if (resp.status == 'success') {
							this.lines = resp.data.linhas;
							this.loaded = true;
						} else {
							toastr.error(
								'Erro ao carregar Requisição inicial!'
							);
							console.log(resp);
						}
					});
				} else {
					toastr.error('Erro ao carregar Requisição inicial!');
					console.log(resp);
				}
			});
		},
	};
</script>
<style scoped>
	.cnt-btn-import {
		width: 100%;
		margin-bottom: 15px;
		/* padding-bottom: 15px;
		border-bottom: 3px solid #cecece; */
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/import/index.vue